import Vue from "vue"
import VueI18n from "vue-i18n"
import App from "./App.vue"
import router from "./router"
import "./registerServiceWorker"

Vue.config.productionTip = false

Vue.use(VueI18n)

const i18n = new VueI18n({
	locale: "en",
	messages: {
		en: require("./locales/en"),
		"zh-HK": require("./locales/zh-HK")
	}
})

new Vue({
	router,
	i18n,
	render: h => h(App)
}).$mount("#app")
